import React from 'react'

export const Header = () => (
  <div className='oglasi-header'>
    <p>Sve kategorije</p>
  </div>
)
